import { useState } from "react";
import { signal } from "@preact/signals-react";

import Dialog from "componentsv2/modal/Dialog";
import { useStoreRest } from "../storeRest";
import SelectField from "./select";
import TableView from "./TableView";
import useMainStore from "store/mainStore";

function TablesModal({ onClose, openModal, shopId, table: table_assigned }) {
  const { store, record, save } = useMainStore();

  const shopAccess = useStoreRest((state) => state.shopAccess);
  const initShop = useStoreRest((state) => state.initShop);
  const [newShop, setNewShop] = useState(shopId);
  const tableSelected = signal(table_assigned);

  const optionsShop =
    shopAccess?.map((shop) => ({
      label: shop.name,
      value: shop.id,
    })) || [];

  async function onChangeShop(e) {
    let shop = e.target.value;
    shop = Number(shop);
    await initShop(shop);
    setNewShop(shop);
  }

  async function handleAccept() {
    record.table_assigned = tableSelected.value;
    store.table_assigned = tableSelected.value.id;
    if (record.shop !== newShop) {
      record.shop = newShop;
      store.shop = newShop;
    }
    if (record.id > 0) {
      await save();
    }
    useMainStore.setState({ record: { ...record } });
    onClose();
  }

  const buttons = [
    { name: "cancel", onClick: onClose },
    { name: "ok", onClick: handleAccept },
  ];

  return (
    <Dialog
      openModal={openModal}
      handleClose={onClose}
      handleAccept={handleAccept}
      buttons={buttons}
      title="Mesas"
      size="w-full sm:w-2/3 lg:w-1/2"
    >
      <div className="flex p-4 mb-4 ml-auto my-auto text-zinc-700">
        <SelectField
          name="shop"
          options={optionsShop}
          value={newShop || ""}
          onChange={onChangeShop}
          className={
            "bg-transparent text-lg font-semibold text-zinc-700 border-none focus:outline-none rounded-md"
          }
        />
      </div>
      <TableView
        defaultShop={newShop}
        onChangeView={onClose}
        selectTable={true}
        tableSelected={tableSelected}
      />
    </Dialog>
  );
}

export default TablesModal;
